import { shallowMount } from "@vue/test-utils";
import ConsultaCA from "@/views/ConsultaCA";

describe("ConsultaCA component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(ConsultaCA, {
      computed: {
        responsiveTerms() {
          return true;
        }
      }
    });
  });

  it("Renders del component ConsultaCA", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
